module.exports = __webpack_public_path__ + "f31983ea02017d5db079c560e172406a.woff2";